import ReactGA from 'react-ga';

import {GOOGLE_ANALYTICS_TRACKING_ID} from '../constants/config.const';

export default class GoogleAnalyticsConfiguration {
  public static initiateGA(): void {
    ReactGA.initialize(GOOGLE_ANALYTICS_TRACKING_ID);
  }

  public static sendPageView(title = "Failware"): void {
    ReactGA.ga("send", "pageview", {
      "page": window.location.pathname.concat(window.location.search),
      "title": title,
      "dimension1": title
    });
  }

  public static sendGAEvents(
    category: string,
    action: string,
    label: string,
    value: number,
    pageId = "Successware"
  ): void {
    ReactGA.event({
      category: category,
      action: action,
      label: label,
      value: value,
      dimension1: pageId
    });
  }
}